import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation } from 'react-query';
import { sendTaskMessageOutbound } from 'RestAPIs/flex-match';

export type SendTaskMessageOutboundPayload = {
  askedTaskId: number;
  body: {
    message: {
      subject?: string;
      body: string;
    };
    type: 'EMAIL' | 'PHONE';
  };
};

const useSendTaskMessageOutbound = () => {
  return useMutation(
    (payload: SendTaskMessageOutboundPayload) =>
      sendTaskMessageOutbound(payload),
    {
      onSuccess: () => {
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useSendTaskMessageOutbound;
